import { render, staticRenderFns } from "./ViewOrden.vue?vue&type=template&id=657daf7b&scoped=true"
import script from "./ViewOrden.vue?vue&type=script&lang=js"
export * from "./ViewOrden.vue?vue&type=script&lang=js"
import style0 from "./ViewOrden.vue?vue&type=style&index=0&id=657daf7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657daf7b",
  null
  
)

export default component.exports